// extracted by mini-css-extract-plugin
export default {"pageContainer":"dyLTiWHh page-container","header":"KTRxezuv","subtitle":"Nwl5eo82"};